export const BlockedMemberListLoading = ({ count = 5 }) => {
  return (
    <div className="grid grid-cols-1 gap-1">
      {[...Array(count)].map((_e, idx) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={idx}
          className="flex space-s-3 items-center p-2 animate-pulse"
        >
          <div className="rounded-avatar bg-skeleton h-10 w-10" />
          <div className="h-5 bg-skeleton rounded-full flex flex-grow" />
        </div>
      ))}
    </div>
  )
}
